import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGenericPayload } from "../../../../../models";
import { IMasterCertificateType } from "../../../../../models/resources/master/ICertificateType";

export interface IMasterOrganismFormState {
    form: IMasterCertificateType;
    loading: boolean;
}

const initialState: IMasterOrganismFormState = {
    form: {
        active: true,
        code: "",
        description: "",
    
    },
    loading: false,
};

export const masterCertificateTypeForm = createSlice({
    name: "masterCertificateTypeForm",
    initialState,
    reducers: {
        resetMasterCertificateTypeForm: () => initialState,
        setLoadingMasterCertificateTypeForm: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setMasterCertificateTypeForm: (state, action: PayloadAction<IMasterCertificateType>) => {
            state.form = action.payload;
        },
        updateMasterCertificateTypeProperty: (state, action: PayloadAction<IGenericPayload>) => {
            state.form = {
                ...state.form,
                [action.payload.name]: action.payload.value,
            };
        },
    },
});

export const {
    resetMasterCertificateTypeForm,
    setLoadingMasterCertificateTypeForm,
    setMasterCertificateTypeForm,
    updateMasterCertificateTypeProperty,
} = masterCertificateTypeForm.actions;

export default masterCertificateTypeForm.reducer;
